import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Outlet } from "react-router-dom";
import ClientHeader from "./ClientHeader";

const ClintLayout = () => {
	return (
		<Box sx={{ minHeight: "100vh", bgcolor: "background.default", overflowX: "hidden" }}>
			<ClientHeader />

			<Container
				maxWidth="lg"
				disableGutters
				sx={{
					mt: { xs: 1, md: 2 },
					px: { xs: 1, sm: 2, md: 3 },
					pb: { xs: 2, md: 4 },
				}}
			>
				<Outlet />
			</Container>
		</Box>
	);
};

export default ClintLayout;
